module.exports = __webpack_public_path__ + "img/jaoc_pizzagame_black-cheese.ad58af16.png";